import styled from 'styled-components';


const ButtonBar = styled.div`
  display: flex;
  flex: auto;
  justify-content: space-evenly;
  width: 100%;
  padding-bottom: 1em;
`;

export default ButtonBar
